if (!customElements.get('liora-product-description')) {
  customElements.define(
    'liora-product-description',
    class LioraProductDescription extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        requestAnimationFrame(() => this.initializeDescription());
      }

      initializeDescription() {
        this.content = this.querySelector('.liora-product-description__content');
        this.button = this.querySelector('.liora-product-description__toggle');

        if (!this.content || !this.button) {
          this.initialized = false;
          return;
        }

        this.collapsedHeight = Number(this.dataset.collapsedHeight) || 150;
        this.style.setProperty('--liora-description-collapsed-height', this.collapsedHeight + 'px');

        this.initializeBenefits();
        this.prepare();
        this.button.addEventListener('click', () => this.toggleDescription());

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            if (this.classList.contains('is-expanded')) {
              this.style.setProperty(
                '--liora-description-expanded-height',
                this.content.scrollHeight + 'px'
              );
            }
          });
          this.resizeObserver.observe(this.content);
        }
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.benefitsObserver) this.benefitsObserver.disconnect();
      }

      initializeBenefits() {
        const benefits = this.querySelector('.liora-product-benefits');
        if (!benefits || !('IntersectionObserver' in window)) return;

        this.benefitsObserver = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            benefits.classList.add('is-visible');
            this.benefitsObserver.disconnect();
          }
        }, { threshold: 0.12 });
        benefits.classList.add('is-motion-ready');
        this.benefitsObserver.observe(benefits);
      }

      prepare() {
        const fullHeight = this.content.scrollHeight;
        this.style.setProperty('--liora-description-expanded-height', fullHeight + 'px');

        if (fullHeight <= this.collapsedHeight + 12) {
          this.button.hidden = true;
          this.classList.remove('is-collapsible', 'is-expanded');
          return;
        }

        this.classList.add('is-collapsible');
        this.button.hidden = false;
      }

      toggleDescription() {
        const expanded = !this.classList.contains('is-expanded');

        if (expanded) {
          this.style.setProperty(
            '--liora-description-expanded-height',
            this.content.scrollHeight + 'px'
          );
        }

        this.classList.toggle('is-expanded', expanded);
        this.button.setAttribute('aria-expanded', String(expanded));
      }
    }
  );
}
